import { MARQUEE } from "./data";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {MARQUEE.map((m) => (
      <span key={m} className="flex items-center">
        <span className="px-8 font-serif text-5xl italic text-white sm:text-7xl">{m}</span>
        <svg viewBox="0 0 20 20" className="h-4 w-4 text-copper-light"><path d="M10 0l2.5 7.5L20 10l-7.5 2.5L10 20l-2.5-7.5L0 10l7.5-2.5z" fill="currentColor" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden bg-navy py-10 sm:py-14" data-testid="materials-marquee">
    <div className="marquee flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
